import React, { useState, useCallback, useRef } from "react";

// ── FIELD DEFINITIONS ─────────────────────────────────────────────────────────
// Matches the real amerind.riskcontrol.expert form HTML exactly

const FIELD_DEFS = {
  // Operations Overview
  executive_summary:        { label: "Executive Summary",                           type: "textarea", section: "Operations Overview" },
  nature_of_operations:     { label: "Nature of Operations",                        type: "select",   section: "Operations Overview",
    options: ["Low-Risk (e.g., Office, Retail)", "Medium-Risk (e.g., Light Manufacturing)", "High-Risk (e.g., Chemical, Heavy Manufacturing)"] },
  number_of_employees:      { label: "Number of Employees",                         type: "text",     section: "Operations Overview" },
  hours_of_operation:       { label: "Hours of Operation",                          type: "text",     section: "Operations Overview" },
  hazardous_materials:      { label: "Hazardous Materials or Processes",            type: "select",   section: "Operations Overview",
    options: ["None", "Minimal (e.g., Cleaning Supplies)", "Moderate (e.g., Combustible Materials)", "High (e.g., Chemicals, Flammable Gases)"] },
  products_services:        { label: "Products or Services",                        type: "textarea", section: "Operations Overview" },
  regulatory_requirements:  { label: "Special Regulatory Requirements",             type: "textarea", section: "Operations Overview" },

  // Building Information
  building_age:             { label: "Building Age",                                type: "text",     section: "Building Information" },
  construction_type:        { label: "Construction Type",                           type: "select",   section: "Building Information",
    options: ["ISO 1-Frame", "ISO 2-Joisted Masonry ", "ISO 3- Non-Combustable", "ISO 4-Masonry Non-Combustable ", "ISO 5-Modified Fire Resistive ", "ISO 6- Fire Resistive "] },
  square_footage:           { label: "Square Footage",                              type: "text",     section: "Building Information" },
  number_of_stories:        { label: "Number of Stories",                           type: "text",     section: "Building Information" },
  occupancy_type:           { label: "Occupancy Type",                              type: "textarea", section: "Building Information" },

  // Roof
  roof_type:                { label: "Roof Type",                                   type: "select",   section: "Roof",
    options: ["Asphalt Shingle Roof", "Metal Roof", "Flat Roof (TPO, PVC,EPDM)", "Mansard", "Other (Specify)", "Modified Bitumen Roof"] },
  roof_condition:           { label: "Roof Condition",                              type: "select",   section: "Roof",
    options: ["Excellent", "Good", "Fair", "Poor"] },

  // Electrical
  electrical_year_updated:  { label: "Year Updated",                                type: "text",     section: "Electrical System" },
  electrical_condition:     { label: "Electrical Condition",                        type: "select",   section: "Electrical System",
    options: ["Modern (Updated within the last 10 years)", "Functional but Aging", "Needs Replacement or Repair", "Unknown"] },
  breaker_types:            { label: "Breaker Types / Generator Details",           type: "textarea", section: "Electrical System" },

  // HVAC
  hvac_type:                { label: "HVAC Type",                                   type: "select",   section: "HVAC",
    options: ["Centralized System", "Individual Units", "Mixed Systems", "Other (Specify)"] },

  // Plumbing
  plumbing_age:             { label: "Plumbing Age",                                type: "text",     section: "Plumbing System" },
  plumbing_condition:       { label: "Plumbing Condition",                          type: "select",   section: "Plumbing System",
    options: ["Excellent (No leaks, modernized)", "Good (Minor wear, no issues)", "Aging (Some leaks or known weaknesses)", "Poor (Frequent issues, needs repairs)"] },
  plumbing_leak_history:    { label: "Any History of Leaks",                        type: "radio",    section: "Plumbing System" },

  // Fire Protection
  fire_protection_type:     { label: "Fire Protection Systems Type",                type: "select",   section: "Fire Protection",
    options: ["Full Sprinkler System", "Partial Sprinkler System", "Fire Alarms Only", "Fire Extinguishers Only", "No Fire Protection Systems Installed"] },

  // Security
  security_type:            { label: "Security Systems Type",                       type: "select",   section: "Security Systems",
    options: ["CCTV", "Intrusion Alarm", "Access Control Systems", "No Security System Installed"] },

  // Property Hazards
  fire_risk_assessment:     { label: "Fire Risk Assessment",                        type: "select",   section: "Property Hazards",
    options: ["Low (Minimal fire load, good proximity to fire services)", "Medium (Moderate fire load, adequate fire services)", "High (High fire load, poor fire service proximity)"] },
  fire_load_narrative:      { label: "Fire Load / Ignition Sources / Combustibility", type: "textarea", section: "Property Hazards" },
  flood_zone:               { label: "Flood Zone Information",                      type: "select",   section: "Property Hazards",
    options: ["Outside Flood Zone", "FEMA Zone X (Minimal Flood Risk)", "FEMA Zone AE (Moderate Flood Risk)", "FEMA Zone A (High Flood Risk)"] },
  earthquake_zone:          { label: "Earthquake Zone",                             type: "select",   section: "Property Hazards",
    options: ["Not in Earthquake Zone", "Zone 1 (Minimal Risk)", "Zone 2 (Moderate Risk)", "Zone 3 (High Risk)"] },
  windstorm_risk:           { label: "Windstorm Risk",                              type: "select",   section: "Property Hazards",
    options: ["Low (Not in Wind-Prone Area)", "Medium (Occasional High Winds)", "High (Hurricane or Tornado-Prone)"] },
  nearby_exposures:         { label: "Nearby Exposures",                            type: "textarea", section: "Property Hazards" },
  fire_wall_condition:      { label: "Condition of Fire Walls and Separations",     type: "select",   section: "Property Hazards",
    options: ["Excellent (Up-to-code, well-maintained)", "Good (Adequate with minor issues)", "Fair (Visible issues but functional)", "Poor (Significant damage or missing)"] },
  property_damage_history:  { label: "History of Property Damage",                  type: "textarea", section: "Property Hazards" },

  // Liability Hazards
  public_access:            { label: "Public Access",                               type: "textarea", section: "Liability Hazards" },
  parking_condition:        { label: "Parking / Sidewalks / Lighting Condition",    type: "select",   section: "Liability Hazards",
    options: ["Excellent (No visible hazards, well-lit)", "Good (Minor wear but functional)", "Fair (Some issues needing attention)", "Poor (Significant hazards present)"] },
  premises_maintenance:     { label: "Premises Maintenance",                        type: "textarea", section: "Liability Hazards" },
  slip_trip_fall:           { label: "Slip/Trip/Fall / Snow & Ice Removal",         type: "select",   section: "Liability Hazards",
    options: ["None", "Minimal", "Moderate", "High"] },
  safety_signage:           { label: "Safety Signage",                              type: "select",   section: "Liability Hazards",
    options: ["Clearly Displayed and Up-to-Date", "Adequate but Needs Updates", "Missing or Poorly Maintained", "None Present"] },
  evacuation_routes:        { label: "Evacuation Routes / EAP",                     type: "textarea", section: "Liability Hazards" },

  // Contractual / Employment
  contractual_exposures:    { label: "Contractual Exposures / Hold Harmless",       type: "textarea", section: "Contractual & Employment" },
  employment_practices:     { label: "Employment Practices",                        type: "textarea", section: "Contractual & Employment" },
  premises_liability:       { label: "Premises Liability",                          type: "textarea", section: "Contractual & Employment" },

  // Safety Programs
  general_safety_programs:  { label: "General Safety Programs",                     type: "select",   section: "Safety Programs",
    options: ["Fully Documented and Regularly Reviewed", "Informal or Partial Safety Program", "No Formal Safety Program"] },
  safety_committees_training: { label: "Safety Committees / Written Programs",      type: "textarea", section: "Safety Programs" },
  employee_safety_training: { label: "Employee Safety Training",                    type: "select",   section: "Safety Programs",
    options: ["Conducted Regularly", "Conducted Occasionally", "No Training Provided"] },
  ppe_training:             { label: "Job-Specific Training / PPE",                 type: "textarea", section: "Safety Programs" },
  incident_response:        { label: "Incident Response Procedures",                type: "select",   section: "Safety Programs",
    options: ["Well-Defined and Followed", "Informal or Incomplete Procedures", "No Procedures in Place"] },
  risk_transfer:            { label: "Risk Transfer / COI Verification",            type: "select",   section: "Safety Programs",
    options: ["Fully Enforced", "Partially Enforced", "Not Enforced"] },

  // Sprinkler Audit
  sprinkler_audit:          { label: "Commercial Sprinkler Audit",                  type: "radio",    section: "Sprinkler Audit" },
  sprinkler_insp_date:      { label: "Date of Most Recent Inspection",              type: "select",   section: "Sprinkler Audit", options: ["Completed", "Not Completed"] },
  sprinkler_inspector:      { label: "Inspector Name and Contact",                  type: "select",   section: "Sprinkler Audit", options: ["Provided", "Not Provided"] },
  sprinkler_system_type:    { label: "Sprinkler System Type",                       type: "select",   section: "Sprinkler Audit", options: ["Wet", "Dry", "Pre-action", "Deluge", "Not Specified"] },
  pump_type:                { label: "Pump Type",                                   type: "select",   section: "Sprinkler Audit", options: ["Electric", "Diesel", "None", "Not Specified"] },
  pump_manufacturer_model:  { label: "Pump Manufacturer and Model Number",          type: "select",   section: "Sprinkler Audit", options: ["Provided", "Not Provided"] },
  backflow_test_date:       { label: "Date of Most Recent Backflow Test",           type: "select",   section: "Sprinkler Audit", options: ["Completed", "Not Completed"] },
  backflow_test_result:     { label: "Backflow Test Results",                       type: "select",   section: "Sprinkler Audit", options: ["Pass", "Fail"] },
  flow_test_date:           { label: "Date of Most Recent Flow Test",               type: "select",   section: "Sprinkler Audit", options: ["Completed", "Not Completed"] },
  flow_test_results:        { label: "Flow Test Results",                           type: "select",   section: "Sprinkler Audit", options: ["PSI & GPM Provided", "Not Provided"] },
  design_placard_photo:     { label: "Design Placard Photo",                        type: "select",   section: "Sprinkler Audit", options: ["Uploaded", "Not Uploaded"] },
  inspection_tags_photo:    { label: "Inspection Tags Photo",                       type: "select",   section: "Sprinkler Audit", options: ["Uploaded", "Not Uploaded"] },
  water_supply_type:        { label: "Primary Water Supply Type",                   type: "select",   section: "Sprinkler Audit", options: ["Municipal", "Private Well", "Other"] },
  main_control_valve:       { label: "Main Control Valve Open and Locked",          type: "radio",    section: "Sprinkler Audit" },
  water_pressure_adequate:  { label: "Adequate Water Pressure/Flow",                type: "radio",    section: "Sprinkler Audit" },
  fdc_condition:            { label: "FDC Condition",                               type: "select",   section: "Sprinkler Audit", options: ["Good", "Needs Maintenance"] },
  inspections_current:      { label: "All Inspections/Tags Up to Date",             type: "radio",    section: "Sprinkler Audit" },
  repairs_required:         { label: "Any Repairs or Adjustments Required",         type: "radio",    section: "Sprinkler Audit" },
  sprinkler_comments:       { label: "General Comments",                            type: "textarea", section: "Sprinkler Audit" },

  // Overall
  overall_risk_rating:          { label: "Rating Based on Surveyed Factors",        type: "select",   section: "Overall Risk Assessment", options: ["Low", "Medium", "High"] },
  underwriting_recommendations: { label: "Underwriting Recommendations",            type: "textarea", section: "Overall Risk Assessment" },
};

const SECTIONS = [...new Set(Object.values(FIELD_DEFS).map(f => f.section))];

// ── DOCX TEXT EXTRACTOR ───────────────────────────────────────────────────────
async function extractDocxText(file) {
  const JSZip = (await loadJSZip());
  const arrayBuffer = await file.arrayBuffer();
  const zip = await JSZip.loadAsync(arrayBuffer);
  const docXml = zip.file("word/document.xml");
  if (!docXml) throw new Error("Not a valid .docx file");
  const xml = await docXml.async("string");
  const parser = new DOMParser();
  const doc = parser.parseFromString(xml, "text/xml");
  const lines = [];
  doc.querySelectorAll("p").forEach(p => {
    const line = Array.from(p.querySelectorAll("t")).map(t => t.textContent).join("").trim();
    if (line) lines.push(line);
  });
  doc.querySelectorAll("tr").forEach(row => {
    const cells = Array.from(row.querySelectorAll("tc"))
      .map(c => Array.from(c.querySelectorAll("t")).map(t => t.textContent).join("").trim())
      .filter(Boolean);
    if (cells.length) lines.push(cells.join(" | "));
  });
  return lines.join("\n");
}

function loadJSZip() {
  return new Promise((resolve, reject) => {
    if (window.JSZip) return resolve(window.JSZip);
    const s = document.createElement("script");
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";
    s.onload = () => resolve(window.JSZip);
    s.onerror = reject;
    document.head.appendChild(s);
  });
}

// ── BOOKMARKLET GENERATOR ─────────────────────────────────────────────────────
function generateBookmarklet(data) {
  // Field name map — real fld... names from the HTML source
  const FIELD_NAMES = {
    executive_summary: "fld1740688964340394779",
    nature_of_operations: "fld1733699425367586711",
    number_of_employees: "fld1733699425367828033",
    hours_of_operation: "fld1733699425367951473",
    hazardous_materials: "fld1733699425367741478",
    products_services: "fld1733699425367161853",
    regulatory_requirements: "fld1733699425367489052",
    building_age: "fld1733699425367828386",
    construction_type: "fld1733699425367533395",
    square_footage: "fld1733699425367589600",
    number_of_stories: "fld1734559391704358611",
    occupancy_type: "fld1733699425367777087",
    roof_type: "fld1733699425367354790",
    roof_condition: "fld1733699425367325387",
    electrical_year_updated: "fld1733699425367656827",
    electrical_condition: "fld1733699425367957363",
    breaker_types: "fld1733699425367260508",
    hvac_type: "fld1733699425367762936",
    plumbing_age: "fld1733699425367201145",
    plumbing_condition: "fld1733699425367176342",
    fire_protection_type: "fld1733699425367395558",
    security_type: "fld1733699425367947130",
    fire_risk_assessment: "fld1733699425367177032",
    fire_load_narrative: "fld1733699425367257897",
    flood_zone: "fld1733699425367188572",
    earthquake_zone: "fld1733699425367493573",
    windstorm_risk: "fld1733699425367386706",
    nearby_exposures: "fld1733699425367303759",
    fire_wall_condition: "fld1733699425367280748",
    property_damage_history: "fld1733699425367945811",
    public_access: "fld173369942536725671",
    parking_condition: "fld1733699425367968567",
    premises_maintenance: "fld1733699425367773310",
    slip_trip_fall: "fld1733699425367393940",
    safety_signage: "fld1733699425367212665",
    evacuation_routes: "fld1733699425367952620",
    contractual_exposures: "fld1733699425367104758",
    employment_practices: "fld1733699425367644734",
    premises_liability: "fld1733699425367340424",
    general_safety_programs: "fld1733699425367583745",
    safety_committees_training: "fld1733699425367615482",
    employee_safety_training: "fld1733699425367656619",
    ppe_training: "fld1733699425367779572",
    incident_response: "fld1733699425367489704",
    risk_transfer: "fld1733699425367714047",
    sprinkler_comments: "fld1735942035081430633",
    overall_risk_rating: "fld1733699425367863975",
    underwriting_recommendations: "fld1733699425367272577",
  };

  const RADIO_VALUES = {
    plumbing_leak_history:   { yes: "1733699425367371643", no: "1733699425367642356" },
    sprinkler_audit:         { yes: "1735942104782620552", no: "1741035572410671440" },
    main_control_valve:      { yes: "173807379714946461",  no: "1738073797184747801" },
    water_pressure_adequate: { yes: "1738073956160827981", no: "1738073956224966335" },
    inspections_current:     { yes: "1738076834051458831", no: "1738076834081616692" },
    repairs_required:        { yes: "1738076990724259386", no: "1738076990764262533" },
  };

  // Build the injection payload — only populated fields
  const payload = {};
  Object.entries(data).forEach(([k, v]) => {
    if (v && FIELD_NAMES[k]) payload[k] = v;
  });

  const code = `
(function(){
  var data = ${JSON.stringify(payload)};
  var fieldNames = ${JSON.stringify(FIELD_NAMES)};
  var radioValues = ${JSON.stringify(RADIO_VALUES)};
  var filled = 0;
  var errors = [];

  // Expand all sections first
  document.querySelectorAll('td.formheader a').forEach(function(a){ try{a.click();}catch(e){} });
  
  setTimeout(function(){
    Object.keys(data).forEach(function(key){
      var val = data[key];
      var fname = fieldNames[key];
      if(!fname || !val) return;

      // Radio fields
      if(radioValues[key]){
        var isYes = (val.toLowerCase() === 'yes');
        var radioVal = isYes ? radioValues[key].yes : radioValues[key].no;
        var radio = document.querySelector('input[type="radio"][value="'+radioVal+'"]');
        if(radio){ radio.click(); filled++; }
        else { errors.push(key+' (radio not found)'); }
        return;
      }

      // Select fields
      var sel = document.querySelector('select[name="'+fname+'"]');
      if(sel){
        for(var i=0;i<sel.options.length;i++){
          if(sel.options[i].text.trim() === val.trim()){
            sel.selectedIndex = i;
            sel.dispatchEvent(new Event('change',{bubbles:true}));
            filled++;
            return;
          }
        }
        errors.push(key+' (option not matched: '+val+')');
        return;
      }

      // Text / textarea fields
      var inp = document.querySelector('[name="'+fname+'"]');
      if(inp){
        inp.value = val;
        inp.dispatchEvent(new Event('change',{bubbles:true}));
        inp.dispatchEvent(new Event('keyup',{bubbles:true}));
        filled++;
      } else {
        errors.push(key+' (field not found)');
      }
    });

    var msg = 'AMERIND RCT: '+filled+' fields filled.';
    if(errors.length) msg += ' Issues: '+errors.join(', ');
    alert(msg);
  }, 800);
})();
  `.trim();

  return "javascript:" + encodeURIComponent(code);
}

// ── MAIN APP ──────────────────────────────────────────────────────────────────
export default function App() {
  const [stage, setStage] = useState("input"); // input | processing | review | ready
  const [inputText, setInputText] = useState("");
  const [propertyName, setPropertyName] = useState("");
  const [file, setFile] = useState(null);
  const [fieldData, setFieldData] = useState({});
  const [activeSection, setActiveSection] = useState(SECTIONS[0]);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");
  const [bookmarklet, setBookmarklet] = useState("");
  const [copied, setCopied] = useState(false);
  const fileRef = useRef();

  const filledCount = Object.values(fieldData).filter(Boolean).length;
  const totalCount = Object.keys(FIELD_DEFS).length;

  // ── PROCESS ───────────────────────────────────────────────────────────────
  async function handleProcess() {
    setProcessing(true);
    setError("");

    let notes = inputText;

    if (file) {
      try {
        if (file.name.endsWith(".docx")) {
          notes = await extractDocxText(file);
        } else {
          notes = await file.text();
        }
      } catch (e) {
        setError("Could not read file: " + e.message);
        setProcessing(false);
        return;
      }
    }

    if (!notes.trim()) {
      setError("Please paste field notes or upload a file.");
      setProcessing(false);
      return;
    }

    try {
      const res = await fetch("/api/map-fields", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ notes, propertyName }),
      });

      const json = await res.json();
      if (!res.ok) throw new Error(json.error || "Mapping failed");

      setFieldData(json.mapped || {});
      setBookmarklet(generateBookmarklet(json.mapped || {}));
      setStage("review");
    } catch (e) {
      setError(e.message);
    }

    setProcessing(false);
  }

  // ── UPDATE FIELD ──────────────────────────────────────────────────────────
  function updateField(key, val) {
    const updated = { ...fieldData, [key]: val };
    setFieldData(updated);
    setBookmarklet(generateBookmarklet(updated));
  }

  // ── DOWNLOAD JSON ─────────────────────────────────────────────────────────
  function downloadJSON() {
    const blob = new Blob([JSON.stringify(fieldData, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${(propertyName || "RCT").replace(/\s+/g, "_")}_fields.json`;
    a.click();
    URL.revokeObjectURL(url);
  }

  // ── COPY BOOKMARKLET ──────────────────────────────────────────────────────
  async function copyBookmarklet() {
    await navigator.clipboard.writeText(bookmarklet);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  }

  // ── STYLES ────────────────────────────────────────────────────────────────
  const s = {
    app: { fontFamily: "'Segoe UI', sans-serif", background: "#f0f4f8", minHeight: "100vh" },
    header: { background: "#1a3a5c", color: "white", padding: "14px 24px", display: "flex", alignItems: "center", gap: 12 },
    logo: { background: "#2563eb", borderRadius: 8, width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 13, letterSpacing: -0.5 },
    title: { fontSize: 17, fontWeight: 600 },
    sub: { fontSize: 12, opacity: 0.7, marginLeft: 4 },
    main: { maxWidth: 1100, margin: "0 auto", padding: "28px 20px" },
    card: { background: "white", borderRadius: 12, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", marginBottom: 20 },
    label: { display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 },
    input: { width: "100%", padding: "9px 12px", border: "1px solid #d1d5db", borderRadius: 7, fontSize: 13, boxSizing: "border-box", fontFamily: "inherit" },
    textarea: { width: "100%", padding: "9px 12px", border: "1px solid #d1d5db", borderRadius: 7, fontSize: 13, boxSizing: "border-box", fontFamily: "inherit", resize: "vertical", minHeight: 90 },
    select: { width: "100%", padding: "9px 12px", border: "1px solid #d1d5db", borderRadius: 7, fontSize: 13, background: "white", boxSizing: "border-box" },
    btnPrimary: { background: "#2563eb", color: "white", border: "none", borderRadius: 8, padding: "10px 22px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
    btnGhost: { background: "transparent", color: "#6b7280", border: "1px solid #d1d5db", borderRadius: 8, padding: "10px 18px", fontSize: 13, cursor: "pointer" },
    btnGreen: { background: "#059669", color: "white", border: "none", borderRadius: 8, padding: "10px 22px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
    error: { background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: 8, padding: "10px 14px", color: "#dc2626", fontSize: 13, marginTop: 12 },
    sectionNav: { display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 20 },
    sectionBtn: (active) => ({ padding: "6px 14px", borderRadius: 20, border: active ? "1px solid #2563eb" : "1px solid #d1d5db", background: active ? "#eff6ff" : "white", color: active ? "#2563eb" : "#374151", fontSize: 12, fontWeight: active ? 600 : 400, cursor: "pointer" }),
    fieldGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 },
    fieldFull: { gridColumn: "1 / -1" },
    fieldCard: { background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: 12 },
    fieldLabel: { fontSize: 11, fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 6 },
    stepBadge: (active) => ({ padding: "3px 10px", borderRadius: 12, fontSize: 11, fontWeight: 600, background: active ? "#2563eb" : "#e5e7eb", color: active ? "white" : "#6b7280", marginRight: 4 }),
    progressBar: { height: 6, background: "#e5e7eb", borderRadius: 3, overflow: "hidden", marginTop: 8 },
    progressFill: (pct) => ({ height: "100%", width: pct + "%", background: pct > 75 ? "#059669" : pct > 50 ? "#2563eb" : "#f59e0b", borderRadius: 3, transition: "width 0.3s" }),
    bookmarkletBox: { background: "#1e293b", borderRadius: 10, padding: 16, fontFamily: "monospace", fontSize: 11, color: "#94a3b8", wordBreak: "break-all", maxHeight: 80, overflow: "hidden", marginTop: 12 },
    instructionStep: { display: "flex", gap: 12, alignItems: "flex-start", marginBottom: 14 },
    stepNum: { background: "#2563eb", color: "white", borderRadius: "50%", width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, flexShrink: 0 },
  };

  return (
    <div style={s.app}>
      {/* Header */}
      <div style={s.header}>
        <div style={s.logo}>RC</div>
        <span style={s.title}>AMERIND Risk Control</span>
        <span style={s.sub}>/ RCT Field Notes Pipeline</span>
        <div style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
          {["Input", "Review", "Inject"].map((step, i) => (
            <span key={step} style={s.stepBadge(
              (i === 0 && stage === "input") ||
              (i === 1 && stage === "review") ||
              (i === 2 && stage === "ready")
            )}>{step}</span>
          ))}
        </div>
      </div>

      <div style={s.main}>

        {/* ── INPUT STAGE ──────────────────────────────────────────────── */}
        {stage === "input" && (
          <div>
            <div style={s.card}>
              <h2 style={{ margin: "0 0 4px", fontSize: 18, color: "#1a3a5c" }}>Upload Field Notes</h2>
              <p style={{ margin: "0 0 20px", color: "#6b7280", fontSize: 13 }}>
                Paste inspection notes, voice memo transcript, or upload a .docx or .txt file.
                Claude will map all content to the RCT form fields automatically.
              </p>

              <label style={s.label}>Property Name</label>
              <input
                style={{ ...s.input, marginBottom: 16 }}
                placeholder="e.g. B-105 Nay Ah Shing Elementary"
                value={propertyName}
                onChange={e => setPropertyName(e.target.value)}
              />

              <label style={s.label}>Paste Field Notes</label>
              <textarea
                style={{ ...s.textarea, minHeight: 200, marginBottom: 12 }}
                placeholder="Paste inspection notes, voice memo transcript, or any field data here..."
                value={inputText}
                onChange={e => setInputText(e.target.value)}
              />

              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                <div style={{ flex: 1, height: 1, background: "#e5e7eb" }} />
                <span style={{ fontSize: 12, color: "#9ca3af" }}>or upload a file</span>
                <div style={{ flex: 1, height: 1, background: "#e5e7eb" }} />
              </div>

              <input ref={fileRef} type="file" accept=".txt,.docx" style={{ display: "none" }}
                onChange={e => setFile(e.target.files[0])} />
              <div
                onClick={() => fileRef.current.click()}
                style={{ border: "2px dashed #d1d5db", borderRadius: 8, padding: "20px", textAlign: "center", cursor: "pointer", color: "#6b7280", fontSize: 13, marginBottom: 16 }}
              >
                {file ? `✓ ${file.name}` : "Click to upload .docx or .txt"}
              </div>

              {error && <div style={s.error}>{error}</div>}

              <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
                <button style={s.btnPrimary} onClick={handleProcess} disabled={processing}>
                  {processing ? "Mapping fields..." : "→ Map to RCT Fields"}
                </button>
                {(inputText || file) && (
                  <button style={s.btnGhost} onClick={() => { setInputText(""); setFile(null); setError(""); }}>
                    Clear
                  </button>
                )}
              </div>
            </div>

            {/* Info cards */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14 }}>
              {[
                { icon: "📋", title: "Paste or Upload", desc: "Field notes, voice transcripts, Word docs, or plain text" },
                { icon: "⚡", title: "Auto-mapped", desc: "Claude extracts and maps all 49 RCT form fields" },
                { icon: "🔖", title: "One-click inject", desc: "Bookmarklet fills the live RCT form automatically" },
              ].map(c => (
                <div key={c.title} style={{ ...s.card, marginBottom: 0 }}>
                  <div style={{ fontSize: 28, marginBottom: 8 }}>{c.icon}</div>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>{c.title}</div>
                  <div style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.5 }}>{c.desc}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── REVIEW STAGE ─────────────────────────────────────────────── */}
        {stage === "review" && (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <div>
                <h2 style={{ margin: 0, fontSize: 18, color: "#1a3a5c" }}>Review & Edit Fields</h2>
                <p style={{ margin: "2px 0 0", fontSize: 13, color: "#6b7280" }}>
                  {propertyName || "Property"} — {filledCount}/{totalCount} fields populated
                </p>
              </div>
              <div style={{ marginLeft: "auto", display: "flex", gap: 10 }}>
                <button style={s.btnGhost} onClick={() => setStage("input")}>← Back</button>
                <button style={s.btnGhost} onClick={downloadJSON}>↓ Download JSON</button>
                <button style={s.btnGreen} onClick={() => setStage("ready")}>→ Get Bookmarklet</button>
              </div>
            </div>

            {/* Progress */}
            <div style={s.card}>
              <div style={{ fontSize: 13, color: "#374151", marginBottom: 4 }}>
                <strong>{filledCount}</strong> of <strong>{totalCount}</strong> fields populated
              </div>
              <div style={s.progressBar}>
                <div style={s.progressFill(Math.round(filledCount / totalCount * 100))} />
              </div>
            </div>

            {/* Section tabs */}
            <div style={s.sectionNav}>
              {SECTIONS.map(sec => (
                <button key={sec} style={s.sectionBtn(activeSection === sec)} onClick={() => setActiveSection(sec)}>
                  {sec}
                </button>
              ))}
            </div>

            {/* Fields */}
            <div style={s.card}>
              <h3 style={{ margin: "0 0 16px", fontSize: 15, color: "#1a3a5c" }}>{activeSection}</h3>
              <div style={s.fieldGrid}>
                {Object.entries(FIELD_DEFS)
                  .filter(([, def]) => def.section === activeSection)
                  .map(([key, def]) => {
                    const val = fieldData[key] || "";
                    const isLong = def.type === "textarea";
                    return (
                      <div key={key} style={{ ...s.fieldCard, ...(isLong ? s.fieldFull : {}) }}>
                        <div style={s.fieldLabel}>{def.label}</div>
                        {def.type === "select" ? (
                          <select style={s.select} value={val} onChange={e => updateField(key, e.target.value)}>
                            <option value="">— select —</option>
                            {def.options.map(o => <option key={o} value={o}>{o}</option>)}
                          </select>
                        ) : def.type === "radio" ? (
                          <div style={{ display: "flex", gap: 16, marginTop: 4 }}>
                            {["Yes", "No"].map(opt => (
                              <label key={opt} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
                                <input type="radio" name={key} value={opt} checked={val === opt} onChange={() => updateField(key, opt)} />
                                {opt}
                              </label>
                            ))}
                          </div>
                        ) : def.type === "textarea" ? (
                          <textarea style={s.textarea} value={val} onChange={e => updateField(key, e.target.value)} />
                        ) : (
                          <input style={s.input} type="text" value={val} onChange={e => updateField(key, e.target.value)} />
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        )}

        {/* ── READY STAGE — BOOKMARKLET ─────────────────────────────────── */}
        {stage === "ready" && (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <h2 style={{ margin: 0, fontSize: 18, color: "#1a3a5c" }}>
                ✓ Ready to Inject — {filledCount} fields
              </h2>
              <button style={{ ...s.btnGhost, marginLeft: "auto" }} onClick={() => setStage("review")}>
                ← Edit fields
              </button>
            </div>

            {/* Instructions */}
            <div style={s.card}>
              <h3 style={{ margin: "0 0 16px", color: "#1a3a5c" }}>How to fill the RCT form</h3>

              <div style={s.instructionStep}>
                <div style={s.stepNum}>1</div>
                <div>
                  <strong style={{ fontSize: 14 }}>Save the bookmarklet</strong>
                  <p style={{ margin: "4px 0 0", fontSize: 13, color: "#6b7280" }}>
                    Drag the button below to your browser bookmarks bar. Do this once — you can reuse it for every inspection.
                  </p>
                </div>
              </div>

              <div style={{ textAlign: "center", margin: "8px 0 20px" }}>
                <a
                  href={bookmarklet}
                  style={{ background: "#1a3a5c", color: "white", padding: "10px 24px", borderRadius: 8, textDecoration: "none", fontSize: 14, fontWeight: 600, display: "inline-block" }}
                  onClick={e => { e.preventDefault(); copyBookmarklet(); }}
                  draggable="true"
                >
                  🔖 AMERIND RCT — Fill Form
                </a>
                <p style={{ fontSize: 11, color: "#9ca3af", marginTop: 8 }}>
                  Drag to bookmarks bar, or click to copy the bookmarklet code
                  {copied && <span style={{ color: "#059669", marginLeft: 8 }}>✓ Copied!</span>}
                </p>
              </div>

              <div style={s.instructionStep}>
                <div style={s.stepNum}>2</div>
                <div>
                  <strong style={{ fontSize: 14 }}>Open the RCT form</strong>
                  <p style={{ margin: "4px 0 0", fontSize: 13, color: "#6b7280" }}>
                    Log in to <strong>amerind.riskcontrol.expert</strong>, open the inspection task form for this property.
                  </p>
                </div>
              </div>

              <div style={s.instructionStep}>
                <div style={s.stepNum}>3</div>
                <div>
                  <strong style={{ fontSize: 14 }}>Click the bookmarklet</strong>
                  <p style={{ margin: "4px 0 0", fontSize: 13, color: "#6b7280" }}>
                    Click <strong>AMERIND RCT — Fill Form</strong> in your bookmarks bar. All {filledCount} fields will fill automatically in under a second. A confirmation popup will tell you how many filled successfully.
                  </p>
                </div>
              </div>

              <div style={s.instructionStep}>
                <div style={s.stepNum}>4</div>
                <div>
                  <strong style={{ fontSize: 14 }}>Complete RIAs and Save</strong>
                  <p style={{ margin: "4px 0 0", fontSize: 13, color: "#6b7280" }}>
                    Review the filled fields, complete the Risk Improvement Actions manually, then click Save in the RCT form.
                  </p>
                </div>
              </div>
            </div>

            {/* Field summary */}
            <div style={s.card}>
              <h3 style={{ margin: "0 0 12px", fontSize: 15 }}>Field Summary — {propertyName || "Property"}</h3>
              <div style={s.progressBar}>
                <div style={s.progressFill(Math.round(filledCount / totalCount * 100))} />
              </div>
              <p style={{ fontSize: 13, color: "#6b7280", marginTop: 8 }}>{filledCount} of {totalCount} fields populated</p>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 8, marginTop: 12 }}>
                {SECTIONS.map(sec => {
                  const secFields = Object.entries(FIELD_DEFS).filter(([, d]) => d.section === sec);
                  const secFilled = secFields.filter(([k]) => fieldData[k]).length;
                  return (
                    <div key={sec} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 10px", background: "#f9fafb", borderRadius: 6 }}>
                      <span style={{ fontSize: 12, color: "#374151" }}>{sec}</span>
                      <span style={{ fontSize: 11, fontWeight: 600, color: secFilled === secFields.length ? "#059669" : "#6b7280" }}>
                        {secFilled}/{secFields.length}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button style={s.btnGhost} onClick={downloadJSON}>↓ Download JSON backup</button>
              <button style={s.btnPrimary} onClick={() => { setStage("input"); setInputText(""); setFile(null); setFieldData({}); setPropertyName(""); }}>
                + New inspection
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
